import { type ApprovalStatus } from '@webapp/components/ApprovalStatusLabel/ApprovalStatusLabel'
import { type PayCardholder, type User } from '@webapp/models'
import { PayRequestStatusEnum } from '@webapp/models/enums'
import { type PayRequest } from '@webapp/models/PayRequest'
import { Card } from '@webapp/modules/spending-cards'

export const formatCardExpiryDate = (expiryDate: string) => {
  if (expiryDate?.length !== 4) return ''

  // Date is formatted MMYY from Pay Card API
  return expiryDate.slice(0, 2).concat('/').concat(expiryDate.slice(2, 4))
}

export const removeWhiteSpace = (val: string) => {
  return val.replace(/\u2000/g, '').replace(/ /g, '')
}

export const convertCentsToDollars = (cents: number) => {
  return cents / 100
}

export const convertDollarsToCents = (dollars: number) => {
  return Number((dollars * 100).toFixed())
}

export const convertUserToCardholder = (user: User): PayCardholder => {
  return {
    id: user.id,
    user_id: user.id,
    email: user.email,
    first_name: user.firstName,
    last_name: user.lastName,
    profile_image: user.profile_image,
    department_id: user.department?.id,
    external_id: undefined,
  }
}

/**
 * Converts a Card entity's cardholder to a PayCardholder object.
 * Only used because CardholderLabel in FundRequestSFormSummary expects
 * snake cased variables. Remove when we are able to support camel case
 * in the Form Summary component specifically Cardholder and User Label components
 * @param card - The Card entity to convert.
 * @return A Partial<PayCardholder> object with the cardholder's details.
 **/
export const convertCardCardholderToCardholder = (
  card: Card
): Partial<PayCardholder> => {
  if (card instanceof Card) {
    return {
      first_name: card.cardholder.firstName,
      last_name: card.cardholder.lastName,
      user_id: card.cardholder.userId,
    }
  }
}

export const getRequestableUser = (card: Card) => {
  return card?.cardholder?.userId
}

export const getApprovalStatus = (request: PayRequest): ApprovalStatus => {
  switch (request.status) {
    case PayRequestStatusEnum.APPROVED:
      return 'approved'
    case PayRequestStatusEnum.DENIED:
      return 'denied'
    case PayRequestStatusEnum.PENDING:
      return 'pending'
  }
}
